module.exports = __webpack_public_path__ + "img/1562906410.97d77e31.jpg";